
                import "css-modules://src_components_grid_grid"
                export default {"Main":"_eb8517","Lines":"_ad4d50","TopLeft":"_f41907","TopRight":"_cb84c4","BottomLeft":"_15bcc8","BottomRight":"_5cacde","Cross":"_23720a","Top":"_007e78","Bottom":"_3cf1b1","Left":"_0e689b","Right":"_49092c"}
            